import { useEffect, useRef, useState } from 'react';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';

export function useHoverPopover() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    store: {
      ui: {
        kalender: { isScrolling },
      },
    },
  } = useRotationsplanFeatureContext();
  const [open, setOpen] = useState(false);
  const [cursorX, setCursorX] = useState(0);

  const handleMouseEnter = (event: React.MouseEvent) => {
    if (!ref.current) {
      return;
    }

    setOpen(true);
    setCursorX(event.clientX - ref.current.getBoundingClientRect().left);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (isScrolling && open) {
      setOpen(false);
    }
  }, [isScrolling, open]);

  return {
    ref,
    open,
    setOpen,
    cursorX,
    handleMouseEnter,
    handleMouseLeave,
  };
}
